<template>
  <div class="event" v-if="this.items.length > 1">
    <span>Épreuves</span>
    <select @change="$emit('change', $event)">
      <option value="0">-- Toutes --</option>
      <option v-for="item in items" :key="item.id" :value="item.id" :title="item.nameFr+' ['+item.id+']'">{{ item.nameFr }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SportGamesFiltersEventEvent',
  computed: {
    items () {
      const filter = this.$store.getters['Sport/Event/filtered']
      return this.$store.getters['Sport/Event/list'].filter(item => filter.indexOf(item.id) > -1)
    }
  }
}
</script>

<style scoped>
  .event{
    display:flex;
    align-items:center;
    margin-bottom:10px
  }
  .event > span{
    font-size:14px
  }
  .event > select{
    height:18px;
    margin-left:5px
  }
</style>
